<template>
    <div :key="key">
        <div class="p-3 my-3 bg-light">
            <strong>梱包情報</strong>
        </div>

        <LogTable
            v-model="value"
            :fields="[
            { key: 'fetch', label: '選択', thStyle: { width: 'auto', }, },
            { key: 'depth', label: '縦cm', thStyle: { width: '8em', }, },
            { key: 'width', label: '横cm', thStyle: { width: '8em', }, },
            { key: 'height', label: '高さcm', thStyle: { width: '8em', }, },
            { key: 'weight', label: '重量kg', thStyle: { width: '8em', }, },
            { key: 'dimensional_weight', label: '容積重量kg', thStyle: { width: '8em', }, tdClass: 'text-right align-middle', },
            ]"
            :defaultRow="{
                name: null,
            }"
            class="deal-items mt-3"
            :showBtnRowMove="false"
            :autoAddRow="true"
            ref="logTable"
            >
            <template v-slot:cell(fetch)="data">
                <vue-select
                    v-model="data.item.fetch"
                    :options="$store.state.app.data.boxes || []"
                    label="name"
                    size="sm"
                    placeholder="手動入力"
                    @input="onInputBoxId($event, data.item)"
                    >
                </vue-select>
            </template>
            <template v-slot:cell(depth)="data">
                <b-form-input
                    v-model="data.item.depth"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    class="text-right no-spin"
                    v-base-numeral-format="{&quot;float&quot;:true}"
                    ></b-form-input>
            </template>
            <template v-slot:cell(width)="data">
                <b-form-input
                    v-model="data.item.width"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    class="text-right no-spin"
                    v-base-numeral-format="{&quot;float&quot;:true}"
                    ></b-form-input>
            </template>
            <template v-slot:cell(height)="data">
                <b-form-input
                    v-model="data.item.height"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    class="text-right no-spin"
                    v-base-numeral-format="{&quot;float&quot;:true}"
                    ></b-form-input>
            </template>
            <template v-slot:cell(weight)="data">
                <b-form-input
                    v-model="data.item.weight"
                    size="sm"
                    style="height:2.45em;"
                    @keydown="$refs.logTable.keybindingForLogTable($event, data)"
                    @focus="$event.target.select()"
                    class="text-right no-spin"
                    v-base-numeral-format="{&quot;float&quot;:true}"
                    ></b-form-input>
            </template>
            <template v-slot:cell(dimensional_weight)="data">
                {{ get_box_dimensinal_weight(data.item) }}
            </template>
            <template v-slot:cell(tracking_code)="data">
                <b-form-input
                    v-model="data.item.tracking_code"
                    size="sm"
                    style="height:2.45em;"
                    @focus="$event.target.select()"
                    ></b-form-input>
            </template>
        </LogTable>

        <b-row>
            <b-col cols="10" xl="11" class="text-right">
                <strong>
                    総重量:
                    <br>
                    総容積重量:
                </strong>
            </b-col>
            <b-col cols="2" xl="1" class="text-right">
                <strong>
                    {{ total.total_weight | BaseNumberFormatter }}
                    kg
                    <br>
                    {{ total.total_dimensional_weight | BaseNumberFormatter }}
                    kg
                </strong>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import AddressContent from '@/components/AddressContent.vue'
import LogTable from '@/components/LogTable.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        AddressContent,
        LogTable,
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        value: {
            type: Array,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
            address_from_id: null,
            address_to_id: null,
            address_importer_id: null,

            order_query: '',
            order_type: 'word',
            data_orders: [],
            data_orders_selected: {},

            data_shipping: {},
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
            'get_boxes_total',
            'get_box_dimensinal_weight',
        ]),
        total() {
            let total = this.get_boxes_total(this.value)
            this.$utils.touch(this.value)
            return total
        },
    },
    mounted() {
    },
    destroyed() {
    },
    methods: {
        onInputBoxId (value, row) {
            let box = {
                depth: null,
                width: null,
                height: null,
                weight: null,
            }
            if (value) {
                box = {
                    depth: value.depth,
                    width: value.width,
                    height: value.height,
                    weight: value.weight,
                }
            }
            this.$utils.set(row, box)

            this.key++
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

